import { useState, useEffect } from 'react';

const COPILOT_STATE_KEY = 'copilot-panel-state';

interface CopilotState {
  isOpen: boolean;
}

export function useCopilot() {
  const [isOpen, setIsOpen] = useState<boolean>(() => {
    try {
      const stored = localStorage.getItem(COPILOT_STATE_KEY);
      if (stored) {
        const state: CopilotState = JSON.parse(stored);
        return state.isOpen;
      }
    } catch (error) {
      console.error('Failed to load copilot state:', error);
    }
    return false;
  });

  useEffect(() => {
    try {
      const state: CopilotState = { isOpen };
      localStorage.setItem(COPILOT_STATE_KEY, JSON.stringify(state));
    } catch (error) {
      console.error('Failed to save copilot state:', error);
    }
  }, [isOpen]);

  const open = (): void => setIsOpen(true);
  const close = (): void => setIsOpen(false);
  const toggle = (): void => setIsOpen((prev) => !prev);

  return {
    isOpen,
    open,
    close,
    toggle,
  };
}
